import { gql } from '@apollo/client';
import { AVAILABILITY_DATA } from './fragments';
import { ID_NAME_FIELDS } from 'graphql/common/fragments';

export const GET_AVAILABILITIES_QUERY = gql`
  query getAvailabilities($search: AvailabilitySearchInput) {
    availabilities(search: $search) {
      results {
        ...availabilityData
        media {
          id
          url
        }
      }
    }
  }
  ${AVAILABILITY_DATA}
`;

export const GET_AVAILABILITY_QUERY = gql`
  query getAvailability($id: ID!, $providerId: Int) {
    availability(id: $id, providerId: $providerId) {
      ...availabilityData
    }
  }
  ${AVAILABILITY_DATA}
`;

export const OCCUPANCY_STATUS_TYPES = gql`
  query occupancyStatusTypes {
    occupancyStatusTypes {
      ${ID_NAME_FIELDS}
    }
  }
`;
